// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Bills API service for legislative review.
 */
import type { NodeApiClient } from '@/app-shell/services'
import type { SessionCode, SyncJobResponse } from '../models/types'

// Re-export document services for convenience
export {
  type DocumentTextResponse,
} from '@/subsystems/documents/services'

/**
 * Trigger an analysis pipeline for a single bill.
 */
export async function triggerAnalyzeBill(
  apiClient: NodeApiClient,
  orgId: string,
  wsId: string,
  pipelineId: string,
  agentId: string | null,
  billNumber: string,
  sessionCode: SessionCode,
  version?: number,
): Promise<SyncJobResponse> {
  const url = `/org/${orgId}/ws/${wsId}/legislative-review/analyze/bill`
  const res = await apiClient.post<SyncJobResponse>(url, {
    pipeline_id: pipelineId,
    agent_id: agentId,
    bill_number: billNumber,
    session: sessionCode,
    version,
  })
  return res.data
}

